module.exports = __webpack_public_path__ + "img/industryScore5.8e972eb5.svg";